import type { PetitionCommentsPageState } from './types';

export const mutations = {
	clearDeleteConfirmMessage: (state: PetitionCommentsPageState): PetitionCommentsPageState => ({
		...state,
		deleteConfirmMessage: false,
	}),

	markCommentAsDeleted: (state: PetitionCommentsPageState, commentId: string): PetitionCommentsPageState => ({
		...state,
		deleteConfirmMessage: true,
		deletedComments: [...state.deletedComments, commentId],
	}),
};
